import styled from "styled-components";

export const JackpotWidgetFooterElementSkeletonBox = styled.div`
    width: 20%;
    height: 2rem;
    
    animation: FooterElementSkeletonAnimation 1.5s linear infinite;
    
    @keyframes FooterElementSkeletonAnimation {
        0% {
            background-color: #474747;
        }
        100% {
            background-color: #333333;
        }
    }
`;